package fr.frux.shared.dto

import kotlinx.serialization.KSerializer
import kotlinx.serialization.descriptors.PrimitiveKind
import kotlinx.serialization.descriptors.PrimitiveSerialDescriptor
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder
import kotlin.time.Instant

/**
 * Sérialise un [Instant] en epoch millis (`Long`), format déjà publié sur le fil (#79).
 *
 * Contrainte de compat absolue : des builds Android publiés consomment ce contrat en JSON
 * `number` (pas de guillemets, pas d'ISO-8601). Migrer les DTOs de `Long` vers `Instant` doit
 * rester interne au typage Kotlin — le JSON produit et attendu ne bouge pas d'un bit. N'importe
 * quel autre format ([Instant] a aussi un `KSerializer` ISO-8601 par défaut côté kotlinx.datetime)
 * casserait ces builds sans avertissement, une simple erreur de parsing chez le client.
 */
object InstantEpochMillisSerializer : KSerializer<Instant> {
    override val descriptor: SerialDescriptor =
        PrimitiveSerialDescriptor("fr.frux.shared.dto.InstantEpochMillis", PrimitiveKind.LONG)

    override fun serialize(
        encoder: Encoder,
        value: Instant,
    ) {
        encoder.encodeLong(value.toEpochMilliseconds())
    }

    override fun deserialize(decoder: Decoder): Instant = Instant.fromEpochMilliseconds(decoder.decodeLong())
}
